import { useTranslation } from "react-i18next";
const QuestionTitleInput = (props) => {
    const { t, i18n } = useTranslation()


    return (
        <div class="mb-3">
            <label for="questionTitle" class="form-label"><b>{t("questionTitle")}</b></label><br />
            <textarea class="form-control" id="questionTitle" />
        </div>
    );
};

export default QuestionTitleInput;